import produce from "immer"
import { REGISTER_ERROR, REGISTER_LOADING } from "./constants";


export const initialState = {
    registerError: null,
    isLoading: false
}

const registerReducer = (state = initialState, action) => 
    produce(state, (draft) => {
        // eslint-disable-next-line default-case
        switch (action.type) {
            case REGISTER_ERROR:
                draft.registerError = action.registerError;
                break;
            case REGISTER_LOADING:
                draft.isLoading = action.isLoading;
                break;
        }
    });


export default registerReducer;
